import { useSuspenseQuery } from '@apollo/client/react';
import { Spinner } from '@chakra-ui/react';
import { Suspense, useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { PageContentRoot } from '#components/page-content-root';
import { GET_DOCUMENT_BY_PATH } from '#graphql/queries/document';
import {
  getDocumentPathFromViewSplat,
  parseAppHistorySplat,
} from '#utils/document-app-path';

import { DocumentHistory } from './document-history';

function HistoryRouteWithData({ documentPath }: { documentPath: string }) {
  const { data } = useSuspenseQuery(GET_DOCUMENT_BY_PATH, {
    variables: { path: documentPath },
  });
  const result = data?.documentByPath;

  const path =
    result?.__typename === 'Document'
      ? result.path
      : result?.__typename === 'DocumentNotFound'
        ? (result.requestedPath ?? documentPath)
        : documentPath;

  return (
    <DocumentHistory
      document={result?.__typename === 'Document' ? result : null}
      path={path}
    />
  );
}

export function DocumentDHistoryRoute() {
  const params = useParams();
  const tail = getDocumentPathFromViewSplat(
    (params as Record<string, string | undefined>)['*'],
  );
  const route = useMemo(() => parseAppHistorySplat(tail), [tail]);
  const documentPath = route.documentPath ?? '';

  if (route.isFilesPage || documentPath.length === 0) {
    return null;
  }

  return (
    <Suspense
      fallback={
        <PageContentRoot
          flex={1}
          alignSelf="stretch"
          display="flex"
          alignItems="center"
          justifyContent="center"
          minH={0}
        >
          <Spinner size="xl" />
        </PageContentRoot>
      }
    >
      <HistoryRouteWithData documentPath={documentPath} />
    </Suspense>
  );
}
